import service from "./service";

export default {
    getSegment() {
        return service.get('/event/run/segment');
    },
    getSched() {
        return service.get('/event/run');
    },
    register(registrant, uuid) {
        return service.post('/event/run/register', {
            registrant: registrant,
            uuid: uuid,
        });
    },
    hasRegistered(uuid) {
        return service.get('/event/run/registered', {
            uuid: uuid,
        });
    },
    sendEmail(email) {
        return service.post('/event/run/email', {
            email: email
        });
    },
    
}